import axios from "axios";

// Global callback invoked when authentication fails permanently (refresh fails)
let authFailureCallback = null;
export function onAuthFailure(cb) {
  authFailureCallback = cb;
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach JWT token to every request if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh expired tokens
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      localStorage.getItem("refresh_token")
    ) {
      originalRequest._retry = true;
      try {
        const { data } = await axios.post(
          `${api.defaults.baseURL.replace("/api", "")}/api/token/refresh/`,
          { refresh: localStorage.getItem("refresh_token") }
        );
        localStorage.setItem("access_token", data.access);
        if (data.refresh) {
          localStorage.setItem("refresh_token", data.refresh);
        }
        originalRequest.headers.Authorization = `Bearer ${data.access}`;
        return api(originalRequest);
      } catch {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        if (authFailureCallback) authFailureCallback();
      }
    }
    // If 401 with no refresh token available, also trigger logout
    if (error.response?.status === 401 && !localStorage.getItem("refresh_token")) {
      localStorage.removeItem("access_token");
      if (authFailureCallback) authFailureCallback();
    }
    return Promise.reject(error);
  }
);

export default api;
